import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Boost } from '@sorare/core/src/atoms/icons/Boost';
import { DropCards } from '@sorare/core/src/atoms/icons/DropCards';
import { Vault } from '@sorare/core/src/atoms/icons/Vault';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import { fantasy } from '@sorare/core/src/lib/glossary';

import type { MyCardsSelectionMode } from '@sorare/marketplace/src/lib/my-cards';

type Props = {
  onClick: (mode: MyCardsSelectionMode) => void;
  canDrop: boolean;
  canSeal: boolean;
  canBoost: boolean;
  displayDropOnboarding: boolean;
};

export const SelectionModeRadios = ({
  onClick,
  canDrop,
  canSeal,
  canBoost,
  displayDropOnboarding,
}: Props) => {
  return (
    <Horizontal>
      {!!canBoost && (
        <Button
          size="compact"
          onClick={() => onClick('boost')}
          startIcon={<Boost size={1.5} color="var(--c-rewards-blue)" />}
          color="tertiary"
        >
          <FormattedMessage {...fantasy.levelUp} />
        </Button>
      )}
      {!!canSeal && (
        <Button
          size="compact"
          onClick={() => onClick('sealing')}
          startIcon={<Vault color="var(--c-rewards-squad)" size={1.5} />}
          color="tertiary"
        >
          <FormattedMessage {...fantasy.seal} />
        </Button>
      )}
      {!!canDrop && (
        <OnboardingHighlightWrapper
          wrap={displayDropOnboarding}
          highlightName="DropCardCta"
        >
          <Button
            size="compact"
            onClick={() => onClick('drop')}
            startIcon={<DropCards size={1.5} />}
            color="tertiary"
          >
            <FormattedMessage
              id="MyCardsSearch.scrapCards"
              defaultMessage="Scrap Cards"
            />
          </Button>
        </OnboardingHighlightWrapper>
      )}
    </Horizontal>
  );
};
